import { GLOW } from "../lib/moduleColors";

// Badge circulaire d'icône de module (accueil : StatWidget, « Il te manque »,
// « En hausse récente », « Progression globale »/« des collections »).
// Icône BLANCHE sur fond plein + halo de la couleur — remplace l'ancien chip
// « icône colorée sur fond teinté à 10% » : une icône fine (ex. TrendingUp
// de « Valeur estimée ») s'y fondait presque entièrement (même teinte que le
// fond, juste plus claire) et ressemblait à un simple pavé de couleur uni,
// signalé par l'utilisateur comme « moche » le 2026-09-28. Un icône blanc
// tranche sur n'importe quelle couleur de fond, quel que soit son dessin.
export const ModuleIcon = ({ icon: Icon, color = "bg-zinc-500", size = "md" }) => {
  const glow = GLOW[color] || "#71717a";
  const dims = size === "sm" ? 30 : size === "lg" ? 42 : 34;
  const iconSize = size === "sm" ? 15 : size === "lg" ? 21 : 17;
  return (
    <span
      className={`module-icon ${color}`}
      style={{
        width: dims, height: dims,
        boxShadow: `0 3px 10px -2px ${glow}99, inset 0 1px 0 rgb(255 255 255 / .25)`,
      }}
    >
      <Icon style={{ width: iconSize, height: iconSize }} className="text-white" strokeWidth={2.25} />
    </span>
  );
};
